import http from "./http";

class RubriquesService {
    index(token){
        return http.get("/api/rubriques",{ headers: { 'Authorization': 'Bearer '+token } })
    }

    store(data,token){
        return http.post("/api/rubriques/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id, token){
        return http.get(`/api/rubriques/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/rubriques/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/rubriques/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/rubriques/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new RubriquesService()